import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["position", "width", "children", "reverseValue", "color", "containerClassName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as i, jsxs as p } from "react/jsx-runtime";
import a from "react";
import { c as b } from "../../../clsx-OuTLNxxd.js";
const r = "InputCheckbox-module_input-checkbox__KxTzV",
  x = "InputCheckbox-module_position-left__CappK",
  _ = "InputCheckbox-module_position-right__XWpNr",
  m = "InputCheckbox-module_width-full__HQ1Fi",
  f = "InputCheckbox-module_disabled__6g1Yu",
  k = "InputCheckbox-module_color-white__h3qRM",
  t = {
    inputCheckbox: r,
    positionLeft: x,
    positionRight: _,
    widthFull: m,
    disabled: f,
    colorWhite: k
  },
  C = (_ref, u) => {
    let {
        position: o = "Left",
        width: c = "auto",
        children: n,
        reverseValue: h = "",
        color: s = "transparent",
        containerClassName: d
      } = _ref,
      e = _objectWithoutProperties(_ref, _excluded);
    const l = /* @__PURE__ */i("label", {
      htmlFor: e.id,
      children: n
    });
    return /* @__PURE__ */p("div", {
      className: b(t.inputCheckbox, d, {
        [t.positionLeft]: o == "Left",
        [t.positionRight]: o == "Right",
        [t.widthFull]: c == "full",
        [t.disabled]: e.disabled,
        [t.colorWhite]: s == "white"
      }),
      children: [/* @__PURE__ */i("input", {
        type: "hidden",
        name: e.name,
        value: h
      }), o == "Right" ? l : "", /* @__PURE__ */i("input", _objectSpread({
        type: "checkbox",
        ref: u
      }, e)), o == "Left" ? l : ""]
    });
  },
  w = /* @__PURE__ */a.forwardRef(C);
export { w as InputCheckbox };